<template>
  <v-container :class="{ 'px-1': $vuetify.breakpoint.smAndDown }" my-1>
    <v-flex xs12 class="text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <h2>Lotes</h2>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="batches"
            class="elevation-1"
            hide-actions
            no-data-text="No hay informacion que mostrar"
            v-bind:pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>
                <router-link :to="batchLink(props.item)">
                  No. {{ props.item.id }}
                </router-link>
              </td>
              <td>
                {{ props.item.send_date | formatDateWithoutTimeZone }}
              </td>
              <td>{{ props.item.label }}</td>
              <td>{{ getStatusTranslation(props.item.status) }}</td>
              <td>
                <router-link :to="bagLink(props.item)">Ver detalle</router-link>
              </td>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 class="right">
          <component-paginator
            :currentPages="page"
            :totalItems="totalItems"
            :itemsPerPage="itemsPerPage"
            v-on:onGoPage="goPage"
          ></component-paginator>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>
<script>
import ComponentPaginator from '../ui/ComponentPaginator';

export default {
  components: {
    ComponentPaginator
  },
  data() {
    return {
      headers: [
        { text: 'Número Lote', value: 'id' },
        { text: 'Fecha Envio', value: 'send_date' },
        { text: 'Etiqueta', value: 'label' },
        { text: 'Estado', value: 'status' },
        { text: 'Operaciones', sortable: false }
      ],
      pagination: { sortBy: 'id', descending: true, rowsPerPage: -1 },
      batches: [],
      totalItems: 1,
      itemsPerPage: 10,
      page: 1
    };
  },

  methods: {
    goPage(page) {
      this.page = page;
      this.retrieveBatches();
    },
    retrieveBatches() {
      var offset = (this.page - 1) * this.itemsPerPage;
      this.axios
        .get(`/batch?limit=${this.itemsPerPage}&offset=${offset}`)
        .then(results => {
          this.batches = results.data.list;
          this.totalItems = results.data.count;
        })
        .catch(error => {
          this.$emit('error', error.message);
        });
    },
    bagLink(bag) {
      return `/batch/${bag.id}/routes`;
    },
    getStatusTranslation(status) {
      if (status === 'OPEN') {
        return 'Abierto';
      } else if (status === 'CLOSE') {
        return 'Cerrado';
      }
      return '';
    },
    batchLink(batch) {
      return `/batch/${batch.id}`;
    }
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.retrieveBatches();
  }
};
</script>
<style scoped>
.right {
  display: flex;
  justify-content: right;
}
.container-table {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100% !important;
  width: 100% !important;
}

.table-content {
  flex: auto !important;
  overflow: auto !important;
  padding: 10px;
}

.paginator-content {
  flex: 0 0 50px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% !important;
}

.item-test {
  height: 100px !important;
  background-color: aquamarine;
}

.row {
  margin: 0px !important;
}
</style>